import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
// Transition Ecosystem
import L from "leaflet";
import "leaflet-providers";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import transitionEffect from "./helpers/transitionEffect";
gsap.registerPlugin(ScrollTrigger);
var te = new transitionEffect();
// Ui item
import GLightbox from "glightbox";
import { carouselWrapper } from "./helpers/CarouselWrapper";
import { sliderWrapper } from "./helpers/SliderWrapper";
import Isotope from "isotope-layout";
// Woocommerce
// require('./woocommerce/Global');
// GDPR Custom System
// require ('./helpers/CookieConsent');
// Controllers
require("./helpers/newsletterController");
var mapGlobal = null;
var iso = null;
// Define all actions
var Site = {
    // Plugins
    carousel: carouselWrapper,
    slider: sliderWrapper,
    // Actions
    init: function () {
        Site.global();
    },
    transition: function (response) {
        Site.global();
        Site.scripts(response);
    },
    global: function () {
        Site.carousel();
        Site.slider();
        GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false
        });
        Site.filters();
        Site.map();
    },
    map: function () {
        if ($("#map").length) {
            try {
                if (mapGlobal != null) {
                    mapGlobal.off();
                    mapGlobal.remove();
                }
                var map_1 = L.map('map', {
                    zoomControl: false,
                    minZoom: 8,
                    maxZoom: 15
                });
                // L.tileLayer.provider("CartoDB.Positron").addTo(map);
                map_1.eachLayer(function (layer) {
                    map_1.removeLayer(layer);
                });
                map_1.touchZoom.disable();
                map_1.scrollWheelZoom.disable();
                var lat = 50.638589;
                var lng = 4.417500;
                map_1.setView([50.55045, 4.34878], 8);
                var mapBounds_1 = L.latLngBounds(L.latLng(51.848674, 2.0), L.latLng(48.868148, 7.652971));
                // map.setMaxBounds(mapBounds);
                var belgiumBounds = L.latLngBounds(L.latLng(49.496407, 6.383176), L.latLng(51.511905, 2.534811));
                map_1.on('drag', function () {
                    map_1.panInsideBounds(mapBounds_1, { animate: false });
                });
                // let franceBounds = L.latLngBounds(L.latLng(51.417709,-5.304834), L.latLng(41.214614,9.889973));
                // var overlay = new L.ImageOverlay("/app/themes/lumber/static/gfx/france-map.png", franceBounds);
                // map.addLayer(overlay);
                var overlay = new L.ImageOverlay("/app/themes/lumber/static/gfx/belgium-map.svg", belgiumBounds);
                map_1.addLayer(overlay);
                L.control.zoom({
                    position: 'bottomleft'
                }).addTo(map_1);
                //
                var icon_1 = new L.Icon({
                    iconUrl: '/app/themes/lumber/static/gfx/icon.svg',
                    iconSize: [30, 30],
                    iconAnchor: [15, 30],
                    popupAnchor: [1, -30],
                    shadowSize: [0, 0]
                });
                $(".on-map").each(function (k, e) {
                    var marker = L.marker([$(e).attr("data-lat"), $(e).attr("data-lng")], { icon: icon_1 });
                    if ($(e).attr("data-description") != "")
                        marker.bindPopup($(e).attr("data-description"));
                    if ($(e).hasClass("descr-in-node")) {
                        marker.bindPopup($(e).html());
                    }
                    marker.addTo(map_1);
                });
                map_1.invalidateSize();
                mapGlobal = map_1;
            }
            catch (error) { }
            setTimeout(function () {
                $(window).trigger("resize");
            }, 150);
        }
    },
    filters: function () {
        if ($("#list-elements").length) {
            $("#filters").on("click", ".more-less a", function (e) {
                e.preventDefault();
                $("#filters").toggleClass("active-all");
            });
            var grid = document.querySelector('#list-elements');
            // filter with selects and checkboxes
            var $selects = $('#filters select');
            var $checkboxes = $('#filters input');
            iso = new Isotope(grid, {
                itemSelector: '.item'
            });
            iso.layout();
            $selects.add($checkboxes).change(function (e) {
                var current = e.currentTarget.checked;
                $(e.currentTarget).parent().parent().find("input:checked").prop("checked", false);
                $(e.currentTarget).prop("checked", current);
                // map input values to an array
                var exclusives = [];
                var inclusives = [];
                // exclusive filters from selects
                $selects.each(function (i, elem) {
                    if (elem.value) {
                        exclusives.push(elem.value);
                    }
                });
                // inclusive filters from checkboxes
                $checkboxes.each(function (i, elem) {
                    // if checkbox, use value if checked
                    if (elem.checked) {
                        inclusives.push(elem.value);
                    }
                });
                // first combine exclusives
                exclusives = exclusives.join('');
                var filterValue;
                if (inclusives.length) {
                    // map inclusives with exclusives for
                    filterValue = $.map(inclusives, function (value) {
                        return value + exclusives;
                    });
                    filterValue = filterValue.join('');
                }
                else {
                    filterValue = exclusives;
                }
                iso.arrange({
                    filter: filterValue
                });
            });
            setTimeout(function () {
                iso.arrange();
            }, 1000);
            if ($('#filters input:checked').length) {
                $checkboxes.trigger("change");
            }
        }
    },
    scripts: function (response) {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
// barba.init({
//     views: [],
//     transitions: [{
//         name: 'opacity-transition',
//         async leave({ current, next, trigger }) {
//             const done = this.async();
//             $('.show-menu').removeClass("show-menu");
//             // te.toggle().eventCallback("onComplete", () => {
//             gsap.to(current.container, {
//                 opacity: 0
//             }).eventCallback("onComplete", () => {
//                 done();
//             });
//             // });;
//         },
//         after(data) {
//             let parser = new DOMParser();
//             let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
//             let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
//             let dataPid = $(htmlDoc).find('notbody').data("pid");
//             document.body.setAttribute('class', bodyClasses);
//             $(window).scrollTo(0);
//             $("#main-header").find(".current-menu-item").removeClass("current-menu-item");
//             let newMenu = $("#main-header").find(".menu-item[data-pid="+ dataPid +"]");
//             if (newMenu.length) {
//                 newMenu.addClass("current-menu-item");
//             }
//             gsap.from(data.next.container, {
//                 opacity: 0
//             })
//             // te.toggle()
//             .eventCallback("onComplete", () => {
//                 // te.removeScreen();
//                 Site.transition(htmlDoc);
//             });
//         }
//     }]
// });
$(document).ready(function () {
    Site.init();
    $("body").on("click", "a[data-goto]", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, [href^='#']", function (e) {
        if (!$(e.currentTarget).hasClass("no-goto")) {
            var elm = $(e.currentTarget).attr("href");
            if ($(elm).length) {
                var posY = $(elm).offset().top - ($("#main-header").height() + 20);
                $.scrollTo(posY, 400);
            }
        }
    });
    var lastScrollTop = 0;
    var scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            $('#main-header').addClass('scrolled');
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    $("body").on("click", "*[data-link]", function (e) {
        document.location = $(e.currentTarget).attr("data-link");
    });
    $("body").on("click", ".about-tab a", function (e) {
        e.preventDefault();
        $(".about-tab .current").removeClass("current");
        $(e.currentTarget).parent().addClass("current");
        $('.tab').hide();
        $($(e.currentTarget).attr("href")).show();
    });
    $("#map-wrapper").hide();
    $("body").on("click", "#switcher a", function (e) {
        e.preventDefault();
        var c = $(e.currentTarget);
        if (c.hasClass("list")) {
            c.removeClass("list").addClass("map");
            $("#list").hide();
            $("#map-wrapper").fadeIn(300, function () {
                // if (mapGlobal != null)
                // mapGlobal.invalidateSize()
                // // $(window).trigger("resize");
                // setTimeout(() => {
                // Site.map();
                // }, 150);
            });
        }
        else {
            c.removeClass("map").addClass("list");
            $("#map-wrapper").hide();
            $("#list").fadeIn(300, function () {
                // $(window).trigger("resize");
                iso.layout();
            });
        }
    });
});
